/**
 * @author wuTao
 * @description 批量审核评语
 * @Date 2020/11/05
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '@/tool';
import 'antd/dist/antd.css';
import { Button } from 'antd';

let { WizContainer, modelUtils } = framework_tool;
let { WizForm, WizSelect, WizButton, WizRow, WizCol } = component_tool;


class BatchAudit extends WizContainer {
  componentName = "batchAudit";

  constructor(props) {
    super(props);
    let isAudit = true;
    if (props.alone && props.record) {
      if (props.record.state != 1) {
        isAudit = false;
      }
    }
    this.state = {
      selectedRows: [],
      ids: [],
      isAudit: isAudit,
    };
    this.initTargetKeys = [];
    this.initTargetRows = [];
    this.values = {};
  }

  _componentWillMount() {
    let { initRows, alone } = this.props;
    if (!alone) {
      if (initRows && initRows()) {
        this.state.selectedRows = initRows();
        this.initTargetRows = initRows();
        initRows().forEach(data => {
          if (data.state != 1) {
            this.state.isAudit = false;
          }
          this.state.ids.push(data.id);
          this.initTargetKeys.push(data.id);
        })
      }
    }
  }

  getSelectRows = (e) => {
    this.state.selectedRows = e;
    this.initTargetRows = e;
    this.state.ids = [];
    e.forEach(data => {
      if (data.state != 1) {
        this.state.isAudit = false;
      }
      this.state.ids.push(data.id);
      this.initTargetKeys.push(data.id);
    })
  };

  /**
   * modal框的确定按钮触发 通过
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = () => {
    this._auditSubmit(2);
  };

  /**
   * modal框的确定按钮触发 驳回
   * 可以在里面增加关闭modal前的操作及校验
   */
  _refuse = () => {
    this._auditSubmit(3);
  };

  /**
   * 提交审核 2 通过；3 驳回
   * @param state
   * @private
   */
  _auditSubmit(state) {
    this.ref.validateFields((err, values) => {
      values['state'] = state;
      if (!values['auditReason'] || values['auditReason'] === null || values['auditReason'] === undefined) {
        values['auditReason'] = '';
      }
      this.values = values;
      if (this.state.ids.length === 0 && !this.props.alone) {
        wizNotice.error("请选择需审核的学员");
      } else if (!this.state.isAudit) {
        wizNotice.error("请选择状态为待审核学员");
      } else if (!err) {
        this._auditCommentResult(values);
      }
      return
    });
  }

  /**
   * 初始化已选学员评语
   */
  _doInitParams = () => {
    this.onChange(this.initTargetKeys, this.initTargetRows)
  };

  onChange = (nextTargetKeys, nextTargetRows) => {
    this.setState({
      ids: nextTargetKeys,
      selectedRows: nextTargetRows
    });
  };

  propsAndStateOnChange = {
    batchUpdate: this._batchUpdate.bind(this),
  };

  _batchUpdate(nextProps, nextState) {
    if (nextProps.batchUpdate.code === 1) {
      wizNotice.success("操作成功");
      this.props.changeModal(false, true, true);
    } else {
      wizNotice.error(nextProps.batchUpdate.msg);
    }
    return true;
  }

  /**
   * 更新 学员审核状态
   * @param values
   * @private
   */
  _auditCommentResult(values) {
    let apiPath = "studentCommentManagement/updateState";
    let payloadKey = "studentComment@batchAudit";
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...values,
          ids: this.props.alone ? [this.props.record.id] : this.state.ids,
        }
      }
    });
  }

  handleClear(id) {
    id
      ? this.setState({
        selectedRows: this.state.selectedRows.filter(item => item.id !== id),
        ids: this.state.ids.filter(item => item !== id)
      })
      : this.setState({
        selectedRows: [],
        ids: []
      });
  }

  //select中的change事件
  _wizSelectOnChange(value, option) {
    let classify = value.map(select => select.key)
    let selectedRows = this.state.selectedRows.filter(filter => classify.indexOf(filter.key) !== -1)
    const selectIds = [];
    selectedRows.forEach(data => {
      selectIds.push(data.id)
    })
    this.setState({
      selectedRows: selectedRows,
      ids: selectIds
    });
  }

  _renderOptions(selectedRows) {
    if (selectedRows && selectedRows.length) {
      return selectedRows.map((row, i) => this._renderOption(row))
    }
    return null
  }

  _renderOption(row) {
    if (row) {
      const fullName = row.fullName;
      return (
        <WizSelect.Option key={row.id} value={fullName} title={fullName}>
          {fullName}
        </WizSelect.Option>
      )
    }
  }

  _renderFooter = () => {
    return (
      <WizRow className="form-btns row-item">
        <WizCol span={24}>
          <WizButton title='通过' type="primary" onClick={this._ok}>通过</WizButton>
          <WizButton title='驳回' type="danger" onClick={this._refuse}>驳回</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  _render() {
    log.info('this.props:', this.props)
    const { classResultLoading, record } = this.props;
    const ids = this.state.ids;
    let columns = [
      {
        name: "ids",
        formItem: {
          type: 'hidden',
          initialValue: { ids }
        },
      },
      this.props.alone ?
        {
          title: "账号",
          name: "userName",
          formItem: {
            initialValue: record.userName,
            disabled: true
          }
        }
        : {}
      ,
      this.props.alone ? {
        title: "姓名",
        name: "fullName",
        formItem: {
          initialValue: record.fullName,
          disabled: true
        }
      }
        : {}
      ,
      {
        title: "审核意见",
        name: "auditReason",
        formItem: {
          type: 'textarea',
          placeholder: '请输入审核意见最多多输入300个字符',
          rows: 5,
          maxlength: 300,
          rules: [],
        },
      }
    ];


    let formProps = {
      ref: 'form',
      columns,
      record: null,
      preview: null,
      footer: this._renderFooter(),
      formItemLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 21 }
      },
      style: { maxWidth: 800 }
    };
    let selectKey = this.state.selectedRows.map(selected => selected.id).join(",");
    const selectedRows = this.state.selectedRows;
    selectedRows.forEach(data => {
      data.key = data.id,
        data.label = data.fullName
    });
    const header = (
      <div style={{ paddingLeft: 15, paddingBottom: 12 }}>
        已选人员<strong> {selectedRows.length} </strong> {'人'}
        <WizButton type="link" onClick={() => this.handleClear()}>清除选择</WizButton>
      </div>
    );

    return (
      <div>
        {!this.props.alone ? <>{header} <WizSelect
          style={{ width: '100%', height: 80, paddingLeft: 15 }}
          key={'wizSelect_' + selectKey}
          defaultValue={this.state.selectedRows}
          labelInValue
          mode={'multiple'}
          open={false}
          onChange={(value, option) => this._wizSelectOnChange(value, option)}
        >
          {this._renderOptions(selectedRows)}
        </WizSelect></> : <></>}
        <WizForm  {...formProps} ref={r => {
          this.ref = r;
        }} />
      </div>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  const { studentCommentManagement } = state;
  const batchUpdate = modelUtils.getModelEntity(studentCommentManagement, 'studentComment@batchAudit');
  const load = modelUtils.getLoadingState(state, ['studentCommentManagement']);
  return {
    batchUpdate: batchUpdate,
    load
  };
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(BatchAudit);
